import React, { useState } from 'react';
import { Box, Typography, Avatar, IconButton } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import AttendanceMiniTimeline from './AttendanceMiniTimeline';
import { getInitials, getAvatarColor, deriveAttendanceDisplay } from './attendanceDisplayUtils';

function AttendanceMobileRow({ attendance, onClick, onImageClick }) {
    const [showPhotos, setShowPhotos] = useState(false);
    const emp = attendance.employees;
    const initials = getInitials(emp?.name, emp?.surname);
    const avatarColor = getAvatarColor(emp?.name);
    const photoEntryUrl = attendance.signedEntryUrl;
    const photoExitUrl = attendance.signedExitUrl;
    const hasPhotos = Boolean(photoEntryUrl || photoExitUrl);

    const {
        workerStartMinutes,
        workerEndMinutes,
        displayStart,
        displayEnd,
        displayHours,
        showOvernightWarning,
    } = deriveAttendanceDisplay(attendance);

    const timeColor = showOvernightWarning ? 'red' : (workerEndMinutes === null ? '#43a047' : 'text.secondary');

    return (
        <Box sx={{ py: 1.25 }}>
            <Box
                onClick={() => onClick(attendance)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    cursor: 'pointer',
                    '&:active': { backgroundColor: 'rgba(0,0,0,0.04)' },
                }}
            >
                <Avatar sx={{ bgcolor: avatarColor, color: 'white', flexShrink: 0 }}>{initials}</Avatar>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="body1" sx={{ fontWeight: 600 }} noWrap>
                        {emp?.name} {emp?.surname}
                    </Typography>
                    <Box sx={{ mt: 0.5, mb: 0.5 }}>
                        <AttendanceMiniTimeline
                            workerStartMinutes={workerStartMinutes}
                            workerEndMinutes={workerEndMinutes}
                        />
                    </Box>
                    <Typography variant="caption" sx={{ color: timeColor }}>
                        {displayStart} → {displayEnd || 'pracuje'}{showOvernightWarning ? ' (+1d)' : ''}
                    </Typography>
                </Box>
                {hasPhotos && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowPhotos(prev => !prev);
                        }}
                    >
                        <CameraAltIcon fontSize="small" />
                    </IconButton>
                )}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                        {displayHours}
                    </Typography>
                    <ChevronRightIcon sx={{ color: 'text.secondary' }} />
                </Box>
            </Box>

            {showPhotos && (
                <Box sx={{ display: 'flex', gap: 1.5, mt: 1, ml: '52px' }}>
                    {photoEntryUrl && (
                        <Box
                            onClick={(e) => e.stopPropagation()}
                            sx={{ width: 64, height: 64, borderRadius: 1, overflow: 'hidden', backgroundColor: '#f0f0f0' }}
                        >
                            <img
                                src={photoEntryUrl}
                                alt="wejście"
                                width={64}
                                height={64}
                                style={{ objectFit: 'cover', cursor: 'pointer' }}
                                onClick={() => onImageClick && onImageClick(photoEntryUrl)}
                            />
                        </Box>
                    )}
                    {photoExitUrl && (
                        <Box
                            onClick={(e) => e.stopPropagation()}
                            sx={{ width: 64, height: 64, borderRadius: 1, overflow: 'hidden', backgroundColor: '#f0f0f0' }}
                        >
                            <img
                                src={photoExitUrl}
                                alt="wyjście"
                                width={64}
                                height={64}
                                style={{ objectFit: 'cover', cursor: 'pointer' }}
                                onClick={() => onImageClick && onImageClick(photoExitUrl)}
                            />
                        </Box>
                    )}
                </Box>
            )}
        </Box>
    );
}

export default AttendanceMobileRow;
